import { AdobeAcrobatSignConfig } from '@monetize/types/app';
import { SettingCardView } from '../../../../../components/Settings/SettingCardView';

interface AdobeAcrobatSignConnectionProps {
  connection: AdobeAcrobatSignConfig;
}

const AdobeAcrobatSignConnection = ({
  connection,
}: AdobeAcrobatSignConnectionProps) => {
  return (
    <SettingCardView
      status={'ACTIVE'}
      actions={[]}
      type="Adobe Acrobat Sign"
      tags={[
        {
          label: 'Access Token',
          value: connection.accessToken,
          colSpan: 1,
        },
      ]}
      onAction={() => {}}
      onEdit={() => {}}
      omitEditButton
    />
  );
};

export default AdobeAcrobatSignConnection;
